import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TShopifyAppsResponsePayload,
	TShopifyAppsStore,
	TShopifyStoresResponsePayload,
} from './types';

export const getShopifyAppsState = (state: TStoreState): TShopifyAppsStore => state.shopifyApps;

export const getShopifyAppsStore = getShopifyAppsState;

// ==========================================:

export const getShopifyApps = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): TShopifyAppsResponsePayload => shopifyApps.shopifyApps,
);

// ==========================================:

export const getShopifyAppsLoader = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): boolean => shopifyApps.shopifyAppsLoader,
);

// ==========================================:

export const getShopifyStores = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): TShopifyStoresResponsePayload => shopifyApps.shopifyStores,
);

// ==========================================:

export const getShopifyStoresLoader = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): boolean => shopifyApps.shopifyStoresLoader,
);

// ==========================================:

export const getAddShopifyAppLoader = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): boolean => shopifyApps.addShopifyAppLoader,
);

// ==========================================:

export const getInstallShopifyStoreLoader = createSelector(
	[getShopifyAppsStore],
	(shopifyApps: TShopifyAppsStore): boolean => shopifyApps.installShopifyStoreLoader,
);
